import './scrolltable.scss';

class Scrolltable {
    constructor (element, options) {
        const defaults = {
            offset: 4,
            scrollNavigation: true
        };

        this.settings = Object.assign({}, defaults, options);

        this.$table = element;

        this.scrollable = false;

        this.scrollStart = true;
        this.scrollEnd = false;

        this.currentColumn = 0;

        this.buildWrapper(() => {
            this.initialize();
        });
    }

    initialize () {
        this.checkScrolltable();

        this.setEvents();
    }

    buildWrapper (callback) {
        const _createElementWithClass = (tag, classname) => {
            const $object = document.createElement(tag);
            $object.classList.add(classname);
            return $object;
        };

        this.$tableCaption = this.$table.querySelector('caption');

        this.$scrollTable = _createElementWithClass('div', 'scrolltable');
        this.$table.parentNode.insertBefore(this.$scrollTable, this.$table);

        this.$scrollTableInner = _createElementWithClass('div', 'scrolltable__inner');
        this.$scrollTable.appendChild(this.$scrollTableInner);

        this.$scrollTableScroller = _createElementWithClass('div', 'scrolltable__scroller');
        this.$scrollTableInner.appendChild(this.$scrollTableScroller);

        this.$scrollTableScrollerInner = _createElementWithClass('div', 'scrolltable__scroller-inner');
        this.$scrollTableScroller.appendChild(this.$scrollTableScrollerInner);

        this.$scrollTableScrollerInner.appendChild(this.$table);

        this.$scrollTableControls = _createElementWithClass('div', 'scrolltable__controls');
        this.$scrollTable.appendChild(this.$scrollTableControls);

        this.$scrollTableProgressbar = _createElementWithClass('div', 'scrolltable__progressbar');
        this.$scrollTableControls.appendChild(this.$scrollTableProgressbar);

        this.$scrollTableProgressbarIndicator = _createElementWithClass('div', 'scrolltable__progressbar-indicator');
        this.$scrollTableProgressbar.appendChild(this.$scrollTableProgressbarIndicator);

        this.$scrollTableButtons = _createElementWithClass('div', 'scrolltable__buttons');
        this.$scrollTableControls.appendChild(this.$scrollTableButtons);

        this.$scrollTablePrevButton = _createElementWithClass('a', 'scrolltable__prev');
        this.$scrollTableButtons.appendChild(this.$scrollTablePrevButton);

        this.$scrollTableNextButton = _createElementWithClass('a', 'scrolltable__next');
        this.$scrollTableButtons.appendChild(this.$scrollTableNextButton);

        this.$tableFirstRow = this.$table.querySelectorAll('tr')[0];
        this.$tableFirstColumns = this.$tableFirstRow.querySelectorAll('th, td');

        if (typeof callback === 'function') {
            callback();
        }
    }

    checkScrolltable () {
        if (this.$scrollTable.offsetWidth < this.$scrollTableScrollerInner.offsetWidth) {
            this.$scrollTable.classList.add('scrolltable--scroll');
        } else {
            this.$scrollTable.classList.remove('scrolltable--scroll');
        }

        this.checkButtons();
    }

    setEvents () {
        this.$scrollTableScroller.addEventListener('scroll', () => {
            this.onScroll(this.$scrollTableScroller.scrollLeft);
        });

        this.$scrollTablePrevButton.addEventListener('click', () => {
            if (this.scrollStart === false) {
                let column = 0;
                if (this.currentColumn > 0) {
                    column = this.currentColumn - 1;
                }
                this.jumpToColumn(column);
            }
        });

        this.$scrollTableNextButton.addEventListener('click', () => {
            if (this.scrollEnd === false) {
                let column = this.$tableFirstColumns.length;
                if (this.currentColumn < this.$tableFirstColumns.length) {
                    column = this.currentColumn + 1;
                }
                this.jumpToColumn(column);
            }
        });

        window.addEventListener('resize', () => {
            this.checkScrolltable();
        });

        window.addEventListener('orientationchange', () => {
            this.checkScrolltable();
        });
    }

    onScroll (scrollLeft) {
        const scrollDistance = Math.round(this.$scrollTableScrollerInner.offsetWidth - this.$scrollTable.offsetWidth);
        let percentage = Math.round(100 / scrollDistance * scrollLeft);

        if (percentage >= 100) {
            percentage = 100;
            this.scrollEnd = true;
            this.scrollStart = false;
        } else if (percentage === 0) {
            this.scrollStart = true;
            this.scrollEnd = false;
        } else {
            this.scrollStart = false;
            this.scrollEnd = false;
        }

        this.setProgress(percentage, scrollLeft);
        this.setCurrentColumn(scrollLeft);
        this.checkButtons();

        if (this.$tableCaption) {
            this.setCaption(scrollLeft);
        }
    }

    setProgress (percentage) {
        const moveDistance = Math.round(this.$scrollTableProgressbar.offsetWidth - this.$scrollTableProgressbarIndicator.offsetWidth);
        const moveStep = Math.round(moveDistance / 100 * percentage);

        this.$scrollTableProgressbarIndicator.style.transform = 'translateX(' + moveStep + 'px)';
    }

    setCaption (scrollLeft) {
        this.$tableCaption.style.transform = 'translateX(' + scrollLeft + 'px)';
    }

    checkButtons () {
        if (this.scrollStart === true) {
            this.$scrollTablePrevButton.classList.add('is--inactive');
        } else {
            this.$scrollTablePrevButton.classList.remove('is--inactive');
        }

        if (this.scrollEnd === true) {
            this.$scrollTableNextButton.classList.add('is--inactive');
        } else {
            this.$scrollTableNextButton.classList.remove('is--inactive');
        }
    }

    setCurrentColumn (scrollLeft) {
        for (let i = 0; i < this.$tableFirstColumns.length - 1; i++) {
            const $currentColumn = this.$tableFirstColumns[i];
            const $nextColumn = this.$tableFirstColumns[i + 1];

            const currentOffset = parseInt($currentColumn.offsetLeft);
            const nextOffset = parseInt($nextColumn.offsetLeft);

            if (this.currentColumn !== i && currentOffset <= scrollLeft && scrollLeft < nextOffset) {
                this.currentColumn = i;
            }
        }
    }

    jumpToColumn (index) {
        const scrollPosition = this.$tableFirstColumns[index].offsetLeft - this.$table.offsetLeft;
        this.$scrollTableScroller.scrollTo({
            top: 0,
            left: scrollPosition,
            behavior: 'smooth'
        });
        this.currentColumn = index;
    }
}

export { Scrolltable };
